﻿import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            getEventsUrl: String,
            strings: Object
        };
    }

    static get targets() {
        return ["calendar"];
    }

    async connect() {
        await this.getAndRenderEvents();
    }

    async getAndRenderEvents() {
        let endDate = new Date(this.calendarTarget.calendar.view.activeEnd.getTime());
        endDate.setDate(this.calendarTarget.calendar.view.activeEnd.getDate() - 1); // our end dates are inclusive
        const queryParams = new URLSearchParams({
            startDate: this.calendarTarget.calendar.view.activeStart.toLocaleDateString("en-GB"),
            endDate: endDate.toLocaleDateString("en-GB")
        });
        const response = await fetch(`${this.getEventsUrlValue}?${queryParams}`, { headers: { "X-Requested-With": "XMLHttpRequest" } });
        const events = await response.json();
        this.calendarTarget.calendar.removeAllEvents();

        for (const event of events) {
            this.calendarTarget.calendar.addEvent(event);
        }
    }

    showEventDetails({ jsEvent, el, event }) {
        if (!bootstrap.Popover.getInstance(el)) {
            const popover = new bootstrap.Popover(el, {
                title: "<strong class='d-block'>" + event.title + "</strong> " + (event.extendedProps.type ? event.extendedProps.type : ""),
                    content: `
<div>
    <div class="fw-bold">${event.allDay ? this.stringsValue.dateLabel : this.stringsValue.startDateLabel}</div>
    <div class="mb-2">${event.extendedProps.start}</div>
    ${!event.allDay
        ? `<div class="fw-bold">${this.stringsValue.endDateLabel}</div>
           <div class="mb-2">${event.extendedProps.end}</div>`
        : ""}
    ${event.extendedProps.location
        ? `<div class="fw-bold">${this.stringsValue.locationLabel}</div>
           <div class="mb-2">${event.extendedProps.location}</div>`
        : ""}
    ${event.url
        ? `<a href="${event.url}">${this.stringsValue.viewDetailsLink}</a>`
        : ""}
</div>`,
                html: true
            });
            setTimeout(() => popover.show(), 0);
        }
        jsEvent.preventDefault();
    }

    calendarTargetConnected() {
        this.calendarTarget.calendar = new Calendar(
            this.calendarTarget,
            {
                plugins: [dayGridPlugin, timeGridPlugin],
                initialView: 'dayGridMonth',
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                height: "auto",
                fixedWeekCount: false,
                showNonCurrentDates: false,
                navLinks: true,
                eventDisplay: "block",
                eventBorderColor: "var(--fc-button-border-color)",
                eventBackgroundColor: "var(--fc-button-bg-color)",
                eventTextColor: "var(--fc-button-text-color)",
                eventTimeFormat: {
                    hour: "numeric",
                    minute: "2-digit",
                    meridiem: "short"
                },
                timeZone: "Europe/London",
                datesSet: () => this.getAndRenderEvents(),
                eventClick: e => this.showEventDetails(e),
                eventContent: function (arg) {
                    const event = arg.event;

                    const container = document.createElement('div');
                    container.classList.add('py-1');
                    container.classList.add('px-1');

                    const timeElement = document.createElement('div');
                    if (!event.allDay) {
                        const startTime = event.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                        timeElement.textContent = startTime;
                    }

                    const titleElement = document.createElement('div');
                    titleElement.innerHTML = `<strong class='d-block'>${event.title}</strong>`;

                    if (event.extendedProps.type) {
                        const typeElement = document.createElement('div');
                        typeElement.textContent = event.extendedProps.type;
                        titleElement.appendChild(typeElement);
                    }

                    container.appendChild(timeElement);
                    container.appendChild(titleElement);

                    return { domNodes: [container] };
                }
            }
        );
        this.calendarTarget.calendar.render();
    }
}